"use client";

import { useEffect } from "react";

export default function Preloader({}) {
  useEffect(() => {
    const container = document.getElementById("preloader");

    if (container && !container.dataset.lottieLoaded) {
      bodymovin.loadAnimation({
        container,
        render: "svg",
        loop: true,
        autoplay: true,
        path: "/preloader/explorer.json",
      });
      container.dataset.lottieLoaded = "true";
    }
  }, []);

  return (
    <>
      <div className="fixed inset-0 flex flex-col items-center justify-center">
        <div className="relative flex w-full flex-col items-center justify-center gap-6 sm:gap-8">
          <div id="preloader" className="w-[140px] sm:w-[200px]" />
          <div className="flex flex-col items-center justify-center text-sm text-muted sm:text-base">
            <span className="font-headline text-xs font-semibold uppercase text-brand-accent">
              Libum Portal
            </span>
            Have your cake, and eat it too
          </div>
        </div>
      </div>
    </>
  );
}
